import { instance } from "..";

// Profile of any user (own = decoded token _id). Returns userInfo:
// { name, gameName, image, level, xp, totalLikes, followersCount,
//   customModesCount, isPremium, specialBadges, levelTitles, gameStats? }
export const getProfile = async (userId) => {
  const { data } = await instance.get(`/api/user/profile/${userId}`);
  return data;
};

// A user's published/owned modes (paginated).
export const getUserModes = async (userId, page = 1, limit = 12) => {
  const { data } = await instance.get(`/api/user/profile-modes/${userId}`, {
    params: { page, limit },
  });
  return data;
};
